import { apiClient } from '../../../helpers/apiHelperV2';
import { FETCH_PRODUCTS_FAILURE, FETCH_PRODUCTS_REQUEST, FETCH_PRODUCTS_SUCCESS, SET_PRODUCTS_FILTER_VALUES } from '../../actionTypes';
import { categoryUrlSelector, standortUrlSelector } from '../../selectors/url';
import { shouldFetch } from '../../fetchStatus';
import { productsResponseSelector } from '../../selectors/standort/vehicleFilter/products';
import { datECodePrefixSelector } from '../../selectors/vehicle';

export const fetchProductsForCategoryIfNeeded = () => {
    return async function (dispatch, getState) {
        const state = getState();

        const standortUrl = standortUrlSelector(state);
        const categoryUrl = categoryUrlSelector(state);
        const productsResponse = productsResponseSelector(state);
        const datECodePrefix = datECodePrefixSelector(state);

        if (shouldFetch(productsResponse.status)) {
            dispatch({
                type: FETCH_PRODUCTS_REQUEST,
                payload: { standortUrl, categoryUrl, datECodePrefix },
            });
            try {
                const res = await apiClient.get(`/api/v1/standorte/${standortUrl}/categories/${categoryUrl}/products`, {
                    params: {
                        datECodePrefix,
                    },
                });

                dispatch({
                    type: FETCH_PRODUCTS_SUCCESS,
                    payload: { standortUrl, categoryUrl, datECodePrefix, data: res.data },
                });
            } catch (error) {
                dispatch({
                    type: FETCH_PRODUCTS_FAILURE,
                    payload: { standortUrl, categoryUrl, datECodePrefix, error },
                });
            }
        }
    };
};

export const setProductsFilterValues = filterValues => {
    return async function (dispatch, getState) {
        const state = getState();

        const standortUrl = standortUrlSelector(state);
        const datECodePrefix = datECodePrefixSelector(state);
        const categoryUrl = categoryUrlSelector(state);

        dispatch({
            type: SET_PRODUCTS_FILTER_VALUES,
            payload: {
                standortUrl,
                datECodePrefix,
                categoryUrl,
                filterValues,
            },
        });
    };
};
